// components/testimonials/TestimonialForm.jsx
import React, { useState, useEffect } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { CustomInput } from "../custom-input/CustomInput";
import { useDispatch } from "react-redux";
import {
  createTestimonialAction,
  updateTestimonialAction,
} from "../../pages/testimonials/TestimonialAction";

const initialState = {
  type: "text",
  category: "success_story",
  name: "",
  title: "",
  content: "",
  videoUrl: "",
  photoUrl: "",
  videoType: "external",
  thumbnail: "",
  role: "",
  organization: "",
  platform: "",
  isFeatured: false,
  isActive: true,
  testimonialDate: "", // ✅ added
};

export const TestimonialForm = ({
  testimonialId,
  initialData, // from list (instant)
  selectedTestimonial, // from fetchSingle (fresh override)
  onClose,
}) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState(initialState);
  const [submitting, setSubmitting] = useState(false);

  // Seed from list immediately
  useEffect(() => {
    if (testimonialId && initialData?._id === testimonialId) {
      setForm({
        ...initialState,
        ...initialData,
        testimonialDate: initialData?.testimonialDate
          ? new Date(initialData.testimonialDate).toISOString().split("T")[0]
          : "",
      });
    } else if (!testimonialId) {
      setForm(initialState);
    }
  }, [testimonialId, initialData]);

  // Override with fetched fresh data when it arrives
  useEffect(() => {
    if (testimonialId && selectedTestimonial?._id === testimonialId) {
      setForm((prev) => ({
        ...prev,
        ...selectedTestimonial,
        testimonialDate: selectedTestimonial?.testimonialDate
          ? new Date(selectedTestimonial.testimonialDate)
              .toISOString()
              .split("T")[0]
          : "",
      }));
    }
  }, [testimonialId, selectedTestimonial]);

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      if (testimonialId) {
        await dispatch(updateTestimonialAction(testimonialId, form));
      } else {
        await dispatch(createTestimonialAction(form));
      }
      onClose?.();
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {submitting && <Spinner animation="border" size="sm" className="mb-3" />}

      <CustomInput
        name="type"
        label="Type*"
        as="select"
        options={["text", "video", "photo"]}
        value={form.type}
        onChange={handleChange}
        required
      />

      <CustomInput
        name="category"
        label="Category*"
        as="select"
        options={[
          "success_story",
          "recent_graduate",
          "current_student",
          "others",
        ]}
        value={form.category}
        onChange={handleChange}
        required
      />

      <CustomInput
        name="name"
        label="Name*"
        value={form.name}
        onChange={handleChange}
        required
      />
      <CustomInput
        name="title"
        label=" Testonomial Title"
        value={form.title}
        onChange={handleChange}
      />

      {/* Content is required for all types */}
      <CustomInput
        name="content"
        label="Content*"
        as="textarea"
        value={form.content}
        onChange={handleChange}
        required
      />

      {form.type === "video" && (
        <>
          <CustomInput
            name="videoType"
            label="Video Type*"
            as="select"
            options={["youtube", "external"]}
            value={form.videoType || ""}
            onChange={handleChange}
            required
          />
          <CustomInput
            name="videoUrl"
            label="Video URL*"
            value={form.videoUrl}
            onChange={handleChange}
            required
          />

          <CustomInput
            name="thumbnail"
            label="Thumbnail URL*"
            value={form.thumbnail}
            onChange={handleChange}
            required
          />
        </>
      )}

      {form.type === "photo" && (
        <>
          <CustomInput
            name="photoUrl"
            label="Photo URL*"
            value={form.photoUrl}
            onChange={handleChange}
            required
          />
          <CustomInput
            name="thumbnail"
            label="Thumbnail URL*"
            value={form.thumbnail}
            onChange={handleChange}
            required
          />
        </>
      )}

      {form.type === "text" && (
        <CustomInput
          name="thumbnail"
          label="Add Image"
          value={form.thumbnail}
          onChange={handleChange}
        />
      )}

      <CustomInput
        name="role"
        label="Role"
        value={form.role}
        onChange={handleChange}
      />
      <CustomInput
        name="organization"
        label="Organization"
        value={form.organization}
        onChange={handleChange}
      />
      <CustomInput
        name="platform"
        label="Platform"
        value={form.platform}
        onChange={handleChange}
      />

      {/* ✅ New Date Field */}
      <CustomInput
        name="testimonialDate"
        label="Testimonial Date"
        type="date"
        value={form.testimonialDate || ""}
        onChange={handleChange}
      />

      <CustomInput
        name="isFeatured"
        label="Featured"
        type="checkbox"
        checked={!!form.isFeatured}
        onChange={handleChange}
      />
      <CustomInput
        name="isActive"
        label="Active"
        type="checkbox"
        checked={!!form.isActive}
        onChange={handleChange}
      />

      <div className="d-grid py-3">
        <Button type="submit" disabled={submitting}>
          {testimonialId ? "Update Testimonial" : "Submit Testimonial"}
        </Button>
      </div>
    </Form>
  );
};
